import {Accordion, Box, HStack, Input, Text} from "@chakra-ui/react";

export function extractFields(obj, prefix = '') {
    const fields = [];
    const sections = [];

    for (const key of Object.keys(obj)) {
        const path = prefix ? `${prefix}.${key}` : key;
        const value = obj[key];

        if (Array.isArray(value)) {
            if (value.length > 0 && typeof value[0] === 'object' && value[0] !== null) {
                sections.push({type: 'section', label: key, path, items: extractFields(value[0], path)});
            } else {
                fields.push({type: 'field', path, label: key, value});
            }
        } else if (typeof value === 'object' && value !== null) {
            sections.push({type: 'section', label: key, path, items: extractFields(value, path)});
        } else {
            fields.push({type: 'field', path, label: key, value});
        }
    }

    return [...fields, ...sections];
}

const FieldRow = ({field, readOnly, mappings, onChange}) => (
    <HStack w="full" gap={3} mb={2}>
        <Text color="text.grey" fontSize={14} w="40%" flexShrink={0} noOfLines={1}>{field.label}</Text>
        {readOnly ? (
            <Input variant="primary" size="sm" value={String(field.value ?? '')} readOnly/>
        ) : (
            <Input
                variant="primary"
                size="sm"
                value={mappings[field.path] ?? ''}
                onChange={(e) => onChange(field.path, e.target.value)}
                placeholder="Variable name..."
            />
        )}
    </HStack>
);

const FieldList = ({items, readOnly, mappings, onChange}) => (
    <>
        {items.map((item) =>
            item.type === 'field' ? (
                <FieldRow key={item.path} field={item} readOnly={readOnly} mappings={mappings} onChange={onChange}/>
            ) : (
                <SectionItem key={item.path} section={item} readOnly={readOnly} mappings={mappings} onChange={onChange}/>
            )
        )}
    </>
);

const SectionItem = ({section, readOnly, mappings, onChange}) => (
    <Accordion.Item value={section.path} bg="bg.card" borderRadius={12} mb={2}>
        <Accordion.ItemTrigger px={3} py={3}>
            <Text color="white" fontSize={14} fontWeight={500}>{section.label}</Text>
            <Accordion.ItemIndicator/>
        </Accordion.ItemTrigger>
        <Accordion.ItemContent>
            <Accordion.ItemBody pb={3} px={3}>
                <FieldList items={section.items} readOnly={readOnly} mappings={mappings} onChange={onChange}/>
            </Accordion.ItemBody>
        </Accordion.ItemContent>
    </Accordion.Item>
);

const JsonMappingForm = ({fields, readOnly = true, mappings = {}, onChange}) => (
    <Box w="full">
        {fields.filter(f => f.type === 'field').map(field => (
            <FieldRow key={field.path} field={field} readOnly={readOnly} mappings={mappings} onChange={onChange}/>
        ))}
        {fields.filter(f => f.type === 'section').length > 0 && (
            <Accordion.Root collapsible multiple mt={2}>
                {fields.filter(f => f.type === 'section').map(section => (
                    <SectionItem key={section.path} section={section} readOnly={readOnly} mappings={mappings} onChange={onChange}/>
                ))}
            </Accordion.Root>
        )}
    </Box>
);

export default JsonMappingForm;
